/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ShiftDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: ShiftDefinitionDto.source;
    label?: string;
    startAt?: string;
    endAt?: string;
}

export namespace ShiftDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
